var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("set-group-for-selected"))),
          ]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              !_vm.useSimpleGroups
                ? _c("app-product-group-select-autcomplete", {
                    attrs: { "use-id": "" },
                    model: {
                      value: _vm.groupId,
                      callback: function ($$v) {
                        _vm.groupId = $$v
                      },
                      expression: "groupId",
                    },
                  })
                : _c("app-product-group-select-autocomplete-simple", {
                    attrs: {
                      "main-group:sync": _vm.simpleMainGroup,
                      "sub-group:sync": _vm.simpleSubGroup,
                    },
                  }),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.isRunning, icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.isRunning, icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }